const sizeClass = {
    xs: "pt-4",
    sm: "pt-8",
    md: "pt-12",
    lg: "pt-20",
    xl: "pt-36",
};

function Spacer({ size = "md" }) {
    return <div className={sizeClass[size] || sizeClass.md}></div>;
}

export default Spacer;
